// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1TBuu","detailsBorder":"styles_detailsBorder__1taRT"};